import { Attendance } from "@/api/openapi";
import { AttendancesContext } from "@/config/contexts";
import { useContext } from "react";

type UseAttendanceMobileElementParams = {
  attendance: Attendance;
};

export function useAttendanceMobileElement({
  attendance,
}: UseAttendanceMobileElementParams) {
  const { selectedMonth, selectedYear } = useContext(AttendancesContext);

  // TODO: this will become only number soon
  const totalHours = attendance.days.reduce(
    (sum, d) => sum + Number(d.theoreticalHours),
    0,
  );
  const totalActualHours = attendance.days.reduce(
    (sum, d) =>
      sum +
      // TODO: this will become only number soon
      Number(d.actualHours) -
      d.giustificativi.reduce((gSum, g) => gSum + Number(g.hours), 0),
    0,
  );

  const hasNote = attendance.note.trim() !== "";
  const hasVoci = attendance.voci.length !== 0;

  return {
    totalHours,
    totalActualHours,
    hasNote,
    hasVoci,
    selectedMonth,
    selectedYear,
  };
}
